import { Module, Mutation, Action } from 'vuex-module-decorators'
import { SystemCodeKey, systemCodeKeyApi } from '@/api'
import { defaultSystemCodeKey } from '@/api/models/system-code/SystemCodeKey'
import BaseStore from '@/store/BaseStore'
import { find } from 'lodash'

@Module({
  name: 'SystemCodeKeyStore',
  namespaced: true,
  stateFactory: true
})
export default class SystemCodeKeyStore extends BaseStore {
  item: SystemCodeKey = defaultSystemCodeKey()

  items: SystemCodeKey[] = []

  get getItem(): SystemCodeKey {
    return this.item
  }

  get allItems(): SystemCodeKey[] {
    return this.items
  }

  get findByCodeKey(): (codeKey: string) => SystemCodeKey {
    return codeKey => {
      return (
        find<SystemCodeKey>(this.items, { key: codeKey }) ??
        defaultSystemCodeKey()
      )
    }
  }

  @Mutation
  public setItem(SystemCodeKey: SystemCodeKey) {
    this.item = SystemCodeKey
  }

  @Mutation
  public setItems(SystemCodeKeys: SystemCodeKey[]) {
    this.items = SystemCodeKeys
  }

  @Mutation
  public updateItems(systemCodeKey: SystemCodeKey) {
    this.items.some((item, index) => {
      if (item.id === systemCodeKey.id) {
        // TODO 直接代入だと算出プロパティが反応せず、下記コードで反応するようになった
        // 解決した事項だが、原因が良く分からないのでコメントしておく
        this.items.splice(index, 1, systemCodeKey)
        return true
      }
    })
  }

  @Action
  public async fetch(id: number) {
    const key = await systemCodeKeyApi.getSystemCodeKey(id)
    this.setItem(key)
  }

  @Action
  public async fetchAll() {
    const keys = await systemCodeKeyApi.getSystemCodeKeys()
    this.setItems(keys)
  }
}
